// extracted by mini-css-extract-plugin
export var legendIndicator = "_e2-1";
export var legendRight = "_e2-0";